'use client';

import { useQuery } from '@tanstack/react-query';
import { contentKeys } from '../queryKeys';
import { getContentPlan } from '../actions/getContentPlan';
import type { ContentCreationPlan } from '../types/contentPlan';
import { whileWaiting } from '@/shared/hooks/liveRefetch';

export function useContentPlan(planId: string | null) {
  const query = useQuery<ContentCreationPlan | null>({
    queryKey: contentKeys.plan(planId ?? ''),
    queryFn: () => getContentPlan(planId!),
    enabled: !!planId,
    staleTime: 2_000,
    refetchInterval: (query) => {
      const plan = query.state.data;
      // content.plan.updated / content.task.updated invalidate this key; the interval is the fallback
      return whileWaiting(!plan || plan.status === 'executing' || plan.status === 'pending', 3_000);
    },
  });
  return query;
}
